// Module
var code = `<div class="plugin-content-container">
  <h3>plugin title is {{title}}</h3>

  <div class="plugin-content-features">
    {{#content.features}}

    <p>{{.*}}</p>

    {{/content.features}}
  </div>
</div>
`;
// Exports
module.exports = code;